import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useDevice } from '@atc/react-device';
import ColorSwatch from '../ColorSwatch/index.js';
import Image from '../Image/index.js';

/**
 *  Generates a checkbox element
 *
 */
const CheckboxWithVisual = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    src,
    colorValue,
    checked = false,
    label,
    labelClassName,
    withCheckmark,
    onChange = () => {},
    secondaryLabel,
    uiContext,
    image,
    ...rest
  } = _ref;
  const [isChecked, setIsChecked] = useState(checked);
  const device = useDevice();
  const isLessThanMd = _get(device, 'lessThan.md', false);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  const handleChange = event => {
    event.persist();
    setIsChecked(state => !state);
    onChange(event);
  };
  const secondLabel = secondaryLabel && /*#__PURE__*/_jsx("div", {
    className: "text-normal"
  }, void 0, secondaryLabel);
  const withAppBreakpoints = Object.keys(rest).filter(breakpoint => {
    const breakpoints = ['xs', 'sm', 'md', 'lg'];
    return breakpoints.includes(breakpoint) && rest[breakpoint];
  }).reduce((obj, key) => {
    obj[key] = rest[key];
    return obj;
  }, {});
  const setBootstrapClassnames = breakpoints => {
    const bootstrapClassnames = Object.keys(breakpoints).reduce((prevValue, val) => {
      const getBreakpointClassname = `col-${val}-${breakpoints[val]}`;
      return prevValue + ' ' + getBreakpointClassname;
    }, '');
    return bootstrapClassnames;
  };
  const getBootstrapClassnames = () => {
    if (uiContext === 'landscape') {
      return setBootstrapClassnames({
        xs: 12
      });
    }
    if (!_isEmpty(withAppBreakpoints)) {
      return setBootstrapClassnames(withAppBreakpoints);
    }
    if (src) {
      return setBootstrapClassnames({
        xs: 6,
        sm: 3,
        md: 6,
        lg: 6
      });
    }
    if (colorValue) {
      return setBootstrapClassnames({
        xs: 3,
        sm: 3,
        md: 6,
        lg: 4
      });
    }
    return setBootstrapClassnames({
      sm: 3,
      md: 6
    });
  };
  const labelClassNames = clsx(getBootstrapClassnames(), {
    'with-visual': true,
    'margin-0': true,
    'hide-checkmark': !withCheckmark,
    checkbox: true,
    labelClassName,
    'input-card-layout': uiContext === 'landscape'
  });
  const thumbnailWidth = () => {
    if (uiContext === 'landscape') {
      return 100;
    }
    return isLessThanMd ? 160 : 118;
  };
  return /*#__PURE__*/_jsx("label", {
    className: labelClassNames,
    "data-cmp": "checkbox"
  }, void 0, /*#__PURE__*/React.createElement("input", Object.assign({
    key: label,
    ref: input => ref && ref.current && ref.current.push(input),
    type: "checkbox",
    onChange: handleChange,
    checked: isChecked
  }, rest)), /*#__PURE__*/_jsx("div", {
    className: clsx('input-label', {
      'align-items-center display-flex gap-2': uiContext === 'landscape',
      'padding-horizontal-0': uiContext !== 'landscape'
    })
  }, void 0, image ?? (src && /*#__PURE__*/_jsx(Image, {
    src: src,
    lazyload: true,
    alt: "" // image is only for decoration
    ,
    width: thumbnailWidth()
  })), colorValue && /*#__PURE__*/_jsx(ColorSwatch, {
    colorValue: colorValue,
    className: "align-self-center"
  }), /*#__PURE__*/_jsx("div", {
    className: clsx({
      'text-center': uiContext !== 'landscape',
      'margin-left-2': uiContext === 'landscape'
    })
  }, void 0, label && /*#__PURE__*/_jsx("div", {}, void 0, label), secondLabel && /*#__PURE__*/_jsx("div", {
    className: "input-secondary-label"
  }, void 0, secondLabel))));
});
export default CheckboxWithVisual;